import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [],
    templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent {

}
